export default "__VITE_ASSET__L0I0FoOD__"